$(function () {
	// タッチイベント用hoverクラス
	document.querySelectorAll(".js_h").forEach((jsh) => {
		["mouseenter", "touchstart"].forEach((event) => {
			jsh.addEventListener(event, () => {
				jsh.classList.add("hover");
			});
		});
		["mouseleave", "touchend"].forEach((event) => {
			jsh.addEventListener(event, () => {
				jsh.classList.remove("hover");
			});
		});
	});

	// ページ内スムーススクロール
	$('a[href^="#"]')
		.not(".dropdown a")
		.click(function () {
			const speed = 500;
			const href = $(this).attr("href");
			const target = $(href === "#" || href === "" ? "html" : href);
			const position = target.offset().top;
			$("html, body").animate({ scrollTop: position }, speed, "swing");
			return false;
		});

	// ページの先頭に戻るボタン
	let showFlag = false;
	let topBtn = $("#page-top");
	topBtn.css("opacity", "-100px");
	//スクロールしたらボタン表示
	$(window).scroll(function () {
		if ($(this).scrollTop() > 0) {
			if (showFlag === false) {
				showFlag = true;
				topBtn.stop().animate({ bottom: "80px" }, 400);
			}
		} else {
			if (showFlag) {
				showFlag = false;
				topBtn.stop().animate({ bottom: "-100px" }, 400);
			}
		}
	});
});
